


















































import { Component, Vue } from "vue-property-decorator";
import payCom from "./payCom.vue";
import artificial from "./artificial.vue";
@Component({
  components: { payCom, artificial },
})
export default class Home extends Vue {
  public active = 0;
  // public mounted() {}
}
